import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import { connect } from 'react-redux';
import {
  cancelSubscription,
  reactivate,
  REACTIVATE_SUCCESS,
  changeSubscription,
  CHANGE_SUCCESS
} from '../../redux/modules/subscriptions';
import { event } from '../../redux/modules/app';
import Questionaire from './unsubscription-questionaire';
import LoadingSpinner from '../../common/loading-spinner';
import tracking from '../../utils/tracking';

import { formatDateTime } from '../../utils/format';
import withQuery from 'app/hooks/withQuery';

// TODO: Get offer from backend... OR load

const OFFER = 'tenantad-79kr-14days';

@connect(
  () => ({}),
  {
    cancelSubscription,
    reactivate,
    changeSubscription,
    event
  }
)
@i18n
class AfterUnsubscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSurvey: false,
      error: null,
      loading: false
    };
  }

  confirmUnsubscription = () => {
    if (this.props.subscription.meta.legacyId) {
      return this.props
        .cancelSubscription(this.props.subscription.meta.legacyId)
        .then(action => {
          this.setState({ showSurvey: true });
          return action;
        });
    }
    const CANCEL_SUBSCRIPTION = `
      mutation CancelSubscription($id: ID!) {
        cancelSubscription(id: $id) {
          id
        }
      }
    `;

    const { mutate } = this.props.mutation;

    mutate(CANCEL_SUBSCRIPTION, {
      id:
        this.props.subscription.nextSubscription?.id ||
        this.props.subscription.id
    }).then(res => {
      this.setState({ showSurvey: true });
      this.props.getSession();
      return res.data?.cancelSubscription;
    });
  };

  // TODO: NOT IN USE
  reactivate(id) {
    this.props.reactivate(id).then(action => {
      const { setSubscription } = this.props;
      if (action.type === REACTIVATE_SUCCESS) {
        setSubscription(null);
      }
      return action;
    });
  }

  cancel = () => {
    const { subscription, setSubscription, event } = this.props;
    event({
      action: 'subscription/cancel-abort',
      data: { subscriptionId: subscription._id }
    });
    setSubscription(null);
  };

  activateNewOffer = () => {
    this.setState({ loading: true });

    const CHANGE_PLAN = `
      mutation ChangePlan($subscription: ID!, $plan: ID!) {
        changePlan(subscription: $subscription, plan: $plan) {
          id
        }
      }
    `;

    const { mutate } = this.props.mutation;
    mutate(CHANGE_PLAN, {
      subscription: this.props.subscription.id,
      plan: OFFER
    })
      .then(res => {
        tracking.prepare();
        tracking.conversion(OFFER, 0, {
          // ref: action.payload.ref
        });
        this.setState({ loading: false });

        if (res.data?.changePlan?.id) {
          this.props.getSession();
          this.props.setSubscription(null);
        }
      })
      .catch(err => {
        if (__DEV__) {
          console.error(err);
        }
      });
  };

  render() {
    const { subscription, setSubscription } = this.props;
    const { error, loading, showSurvey } = this.state;
    if (!showSurvey) {
      return (
        <div className="after-unsubscription col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3">
          <div className="panel panel-danger">
            <div className="panel-heading">
              <h3 className="text-center" style={{ margin: 0 }}>
                Vigtigt ved afmelding
              </h3>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <i className="fa fa-warning" /> Du kan <b>ikke</b> benytte dig
                af en ny prøveperiode til lav pris
              </li>
              <li className="list-group-item">
                <i className="fa fa-warning" /> Din boligsøgerannonce er{' '}
                <b>ikke</b> længere synlig for udlejere
              </li>
              <li className="list-group-item">
                <i className="fa fa-warning" /> Du kan <b>ikke</b> længere se og
                modtage svar på beskeder sendt til udlejere gennem Boligninja.dk
              </li>
            </ul>
          </div>
          <div className="buttons">
            <button
              className="btn btn-primary"
              onClick={this.cancel /*() => this.reactivate(subscription._id)*/}
            >
              {this.i18n('Fortryd afmelding')}
            </button>
            &nbsp;&nbsp;
            <button
              className="btn btn-danger pull-right"
              onClick={this.confirmUnsubscription}
            >
              {this.i18n('Afmeld')}
            </button>
          </div>
        </div>
      );
    }

    const alternativeOffer =
      subscription.offer !== OFFER ? (
        <Col sm={6} className="after-unsubscription">
          <div
            className="pricing"
            onClick={this.activateNewOffer}
            style={{ paddingLeft: '15px', paddingRight: '15px' }}
          >
            <h3 style={{ marginTop: 0 }}>
              {this.i18n('Skift til begrænset adgang')}
            </h3>
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: 'center' }}>
                <div className="price">
                  <span className="per">kun&nbsp;</span>
                  79
                  <span className="per">,- kr. *</span>
                </div>
                <div className="billing">hver 14. dag i løbende abonnement</div>
                <div className="planname" />
              </div>
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <div className="alt-offer">
                  <i className="fa fa-group" />
                </div>
                <div className="alt-offer-text">
                  kontakt max 10 udlejere per 14 dage
                </div>
              </div>
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <div className="alt-offer">
                  <i className="fa fa-envelope-o" />
                </div>
                <div className="alt-offer-text">
                  modtag og se svar fra udlejere
                </div>
              </div>
            </div>
          </div>
          <p style={{ marginTop: '5px' }}>
            * Hver 14. dag fornyes abonnementet automatisk indtil det afmeldes
          </p>
          {error ? (
            <div className="payment-errors alert alert-danger" role="alert">
              {this.i18n(this.state.error)}
            </div>
          ) : null}
          {loading ? <LoadingSpinner /> : null}
        </Col>
      ) : null;

    const questionaireSize = alternativeOffer
      ? {
          sm: 6
        }
      : {
          sm: 6,
          smOffset: 3
        };

    return (
      <div>
        <Col {...questionaireSize} className="after-unsubscription">
          <h5>
            {this.i18n(
              'Din boligsøgerannonce er afmeldt til udløb %s',
              formatDateTime(subscription.endingAt)
            )}
          </h5>
          <br />
          <Questionaire
            setSubscription={setSubscription}
            subscription={subscription._id}
          />
          <hr />
        </Col>
        {alternativeOffer}
      </div>
    );
  }
}

export default withQuery(AfterUnsubscription);
